























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  locale(translationKey: string) {
    return this.$t(`footer.${translationKey}`);
  }
  showIfLocaleExists(translationKey: string) {
    return this.$te(`footer.${translationKey}`) ? this.locale(translationKey) : '';
  }
}
